import { createFileRoute } from "@tanstack/react-router";
import { alternateLinkList } from "@/lib/i18n/locale";
import { AffiliateVietnamPage } from "./legal.affiliate-vietnam";

export const Route = createFileRoute("/vi/legal/affiliate-vietnam")({
  head: () => ({
    meta: [{ title: "Chương trình Affiliate (Việt Nam) — Banana Cards" }],
    links: alternateLinkList("/legal/affiliate-vietnam", "vi"),
  }),
  component: AffiliateVietnamPage,
});